<!-- 课堂记录 自然拼读 -->
<template>

    <el-row class="main-box">
				<el-col class="listdivcls" :offset="7" :span="10">
					<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
						课程记录</div>
						<div style="height: 20px;"></div>
					<div  class="flex-colmn f-align-center" v-for="(itemdata, indexdata) in datali" :key="indexdata" >
						<div class="itemhead flex-row f-align-center">
							<div class="itemhead_title  flex-row f-align-center">
								<img  style="margin-left: 10px;width: 26px;height: 26px;" mode="fill" :src="require('@/static/new_kc_ic2.png')"  />
								<span style="margin-left: 8px;" >教学单词</span>
							</div>
							<span style="margin-left: 30px;font-family: 思源黑体;font-size: 24px;font-weight: bold;line-height: normal;color: #0AA26B;" >
								{{itemdata.keyword}}</span>
						</div>
						<div  class="itembgcls flex-row f-align-center f-justify-between" v-for="(itemdata2, indexdata2) in itemdata.values.type1.values" :key="indexdata2" @click="startxx(itemdata2)">
							<span v-html="gethtml(itemdata2)" ></span> 
							<span >{{itemdata2.chinese}}</span>
						</div>
					<div class="itemhead flex-colmn" style="margin-top: 31px;">
							<div class="itemhead_title  flex-row f-align-center">
								<img  style="margin-left: 10px;width: 26px;height: 26px;" mode="fill" :src="require('@/static/new_kc_ic2.png')"  />
								<span style="margin-left: 8px;" >学后练习</span>
							</div>
						</div>
						
						<div class="textcls" style="margin-top: 19px;">
							<div  class="itemtextcls flex-row f-align-center " v-for="(itemdata3, indexdata3) in itemdata.values.type2.values" :key="indexdata3" >
								<span >{{itemdata3.word}}</span>
								<span style="color: #333333;margin-left: 10px;" >{{itemdata3.chinese}}</span>
							</div>
						</div>
						
						
					</div>
						
					
				</el-col>
				
				<audio   ref="audio">
					<source :src="playsrc" type="audio/mp3"/>
				</audio>
    </el-row>
	

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Loading } from 'element-ui';
export default {
    data() {
        return {
			datali:[
			],
			id:"",
			courseId:"",
			playsrc:"",
			isplay:false,
			showind:-1,
			}
    },
    computed: {
      ...mapState([
          'userToken',
		   'userInfos',
      ]),
      ...mapGetters(["getUserToken"])
    },
	created() {
		this.id = decodeURIComponent(this.$route.query.id);
		this.courseId = decodeURIComponent(this.$route.query.courseId);
	    this.getdata();
	},
    methods: {
		gethtml(itemdata2){
			var content=itemdata2.word;
			if (itemdata2.keywordIndex&&itemdata2.keywordIndex.length>=10) {
				return itemdata2.keywordIndex;
			} else{
			const textToColor = itemdata2.keyword;
			var reg = "/"+textToColor+"/g";
			console.log("!!!!"+reg);
			return content.replace(eval(reg), `<span style="color: #0AA26B;">${textToColor}</span>`);
			}
		},
		startxx(itemdata){
				this.play(itemdata.pronunciation);
		},
		clic(index){
			this.showind=index;
		},
		async requsturl(id){
			if(this.isplay)
			{
				return;
			}
			this.isplay=true;
			    let res = await this.$api.get("/web/teacher/home/selectWordPronunciation", {
			        headers: { //头部参数
			            frontUserToken: this.getUserToken
			        },
					params:{
						id :id,
					 }
			    });
				this.isplay=false;
				if(res.code==200)
				{
					this.play(res.data.pronunciation);
				}
		},
		play(url)
		{
				this.playsrc=url;
			let music1 = new Audio();
			 
			      music1 = url;
			 
			      this.$refs.audio.src = music1;
			 let audioPlayer = this.$refs.audio;
			 audioPlayer.playbackRate = 1.2;
		// 	      this.$refs.audio.play();
		
			this.$refs.audio.play();
		}, finish(){
			this.$router.back();
		 },
		async getdata() {
		    let res = await this.$api.get("/web/phonics/classSalesRecordPhonicsInfo", {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        },
				params:{
					id:this.id ,
				 }
		    });
			if(res.code==200)
			{
				if(res.data==null||res.data.length<=0)
				{
					this.$message({
					  type: "warning",
					  message: "沒有课程记录！"
					});
						this.$router.back();
				}
				
				this.datali=res.data;
			}
		},
    }
}
</script>

<style lang="scss" scoped>
.main-box {
    width: 100%;
	flex: 1;
    background: #B6E4D3;
    position: relative;
	padding-top: 84px;
	
	
	// itemhead itemhead_title
	
	.itemhead{
		height: 41px;
		margin-left: 30px;
		margin-right: 30px;
		border-bottom-color:#0AA26B ;
		border-bottom-width: 1px;
		border-bottom-style: solid;
	}
	
	.itemhead_title{
		width: 162px;
		height: 41px;
		background: url(../static/new_kc_ic1.png) no-repeat;
		background-size: 100% 100%;
		
		font-family: Source Han Sans;
		font-size: 24px;
		font-weight: 500;
		line-height: normal;
		letter-spacing: 0em;
		font-variation-settings: "opsz" auto;
		font-feature-settings: "kern" on;
		/* 纯白 */
		color: #FFFFFF;
	}
	
	.textcls{
		margin-left: 30px;
		margin-right: 30px;
		display: flex;
		flex-wrap: wrap;
		padding-bottom: 41px;
	}
	
	.itemtextcls{
		font-family: Source Han Sans;
		font-size: 16px;
		font-weight: bold;
		line-height: 50px;
		letter-spacing: 0em;
		padding-right: 30px;
		
		font-feature-settings: "kern" on;
		/* 绿 */
		color: #0AA26B;
	}
	
	.listdivcls{
	  border-radius: 20px;
	  background: #E5F3F1;
	  padding-top: 24px;
	  font-family: Oswald;
	  font-size: 36px;
	  font-weight: normal;
	  line-height: normal;
	  text-align: center;
	  letter-spacing: 0em;
	  font-feature-settings: "kern" on;
	  /* 绿 */
	  color: #0AA26B;
	  
	  @media screen and (max-width: 1400px)  {
	   	  font-size: 26px;
	   }
	   
	   @media screen and (max-width: 1000px)  {
	    	  font-size: 20px;
	    }
	}
	
	
	.itembgcls{
		padding-left: 38px;
		padding-right: 38px;
		cursor: pointer;
		/* 矩形 55 */
		margin-left: 30px;
		margin-right: 30px;
		height: 80px;
		border-radius: 100px;
		opacity: 1;
		margin-top: 23px;
		/* 纯白 */
		background: #FFFFFF;
		box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
		
		font-family: PingFang SC;
		font-size: 36px;
		font-weight: normal;
		line-height: normal;
		text-align: center;
		letter-spacing: 0em;
		
		font-variation-settings: "opsz" auto;
		/* 333333 */
		color: #333333;
	}
	
	.xcls{
		height: 307px;
		border-radius: 20px;
		opacity: 1;
		background: #FFFFFF;
		
		
		.dccls{
			margin-left: 15px;
			margin-right: 15px;
			height: 76px;
			border-radius: 20px;
			opacity: 1;
			background: linear-gradient(330deg, #FFFFFF 14%, #D9F1E5 77%);
			box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);
	
		}
		
		.text11{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 已选择 */
			font-family: 思源黑体;
			font-weight: 400;
			font-size: 18;
			color: #ACBEB0
		}
		
		.text12{
			font-family: Oswald;
			font-size: 36px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
		}
		
		.text13{
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;
			font-family: Source Han Sans;
			font-weight: 400;
			font-size: 18px;
			color: #333333
		}
		
		
		.text14{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
		}
		
		.text15{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 红 */
			color: #ED6565;
		}
		
		.bucls1{
			margin-left: 15px;
			margin-right: 15px;
			 cursor: pointer;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			text-align: center;
			/* 绿 */
			background: #0AA26B;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: bold;
			line-height: 46px;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 纯白 */
			color: #FFFFFF;
		}
		
		.bucls2{
			margin-left: 15px;
			margin-right: 15px;
			 cursor: pointer;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			
			box-sizing: border-box;
			/* 绿 */
			border: 2px solid #0AA26B;
			text-align: center;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: normal;
			line-height: 46px;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
		}
	}
	
	.appraise-popup-title {
	    width: 100%;
	    height: 86px;
	    border-radius: 20px 20px 0 0;
	    background: #0AA26B;
	    box-sizing: border-box;
	    padding: 0 35px;
	
	    .appraise-popup-title-name {
	        font-family: 思源黑体;
	        font-size: 26px;
	        font-weight: bold;
	        line-height: normal;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 纯白 */
	        color: #FFFFFF;
	    }
	
	    img {
	        width: 56px;
	        height: 56px;
	    }
	}
	.start-popup-content {
	    background: #fff;
	    border-radius: 0 0 20px 20px;
	    box-sizing: border-box;
	    padding: 0 52px;
	
	    .start-popup-content-text1 {
	        margin-left: 173.5px;
	        margin-top: 89px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 333333 */
	        color: #333333;
	    }
	
	    .start-popup-content-timebox {
	        margin-top: 30px;
	        margin-left: 173.5px;
	
	        span {
	            margin-right: 30px;
	            font-family: 思源黑体;
	            font-size: 22px;
	            font-weight: normal;
	            line-height: 30px;
	            letter-spacing: 0em;
	
	            font-feature-settings: "kern" on;
	            /* 333333 */
	            color: #333333;
	        }
	
	        div {
	            width: 195px;
	            height: 64px;
	            border-radius: 100px;
	            opacity: 1;
	
	            background: #E5F7F1;
	
	            box-sizing: border-box;
	            border: 1px solid rgba(10, 162, 107, 0.2);
	        }
	
	    }
	
	    .start-popup-content-tipsbox {
	        margin-top: 89px;
	        margin-bottom: 75px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 确认开始学员 */
	        color: #333333
	    }
	
	    .start-popup-content-line {
	        margin-top: 30px;
	        width: 741.5px;
	        height: 0px;
	        opacity: 1;
	
	        border: 1px solid rgba(10, 162, 107, 0.2);
	    }
	
	    .start-popup-content-btnsbox {
	        margin-top: 31px;
	        margin-bottom: 30px;
	
	        div {
	            &:first-child {
	                margin-right: 20px;
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 灰 */
	                background: #ACBEB0;
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	
	            &:last-child {
	
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 绿 */
	                background: #0AA26B;
	
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	        }
	    }
	
	}
	
}





/deep/ .el-dialog__header {
    border-radius: 20px 20px 0 0;
    padding: 0;

}

/deep/ .el-dialog__body {
    border-radius: 20px;
    padding: 0;
}

/deep/ .el-dialog {
    background: transparent;
    border-radius: 20px;
    box-shadow: 0 0px 0px #ccc;

    @media screen and (min-width: 992px) {
        width: 44.114%;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        width: 82.395%;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }




}
</style>